import { useUserStore } from '@/stores/user.js'
import type { RouteLocationNormalized } from 'vue-router'

interface AuthContext {
  next: (location?: any) => void
  to: RouteLocationNormalized
}

export default async function auth({ next, to }: AuthContext) {
  try {
    const userStore = useUserStore()
    if (!userStore.user) {
      sessionStorage.setItem('redirectAfterLogin', to.fullPath)
      return next({ name: 'login' })
    } else if (userStore.user.banned === 1) {
      sessionStorage.setItem('redirectAfterLogin', to.fullPath)
      return next({ name: 'login' })
    } else if (userStore.user.email_verified === 0) {
      sessionStorage.setItem('redirectAfterLogin', to.fullPath)
      return next({ name: 'signup-confirm' })
    }
    return next()
  } catch (e) {
    sessionStorage.setItem('redirectAfterLogin', to.fullPath)
    return next({ name: 'login' })
  }
}
